import { Language } from 'src/app/classes/Language.class';

const languages: Language[] = [
  { code: 'en', name: 'Englisch' },
  { code: 'de', name: 'Deutsch' },
];

const languagesEN: Language[] = [
  { code: 'en', name: 'English' },
  { code: 'de', name: 'German' },
];

export function getLanguage(code: string): Language[] {
  return languages.filter(data => {
    if (data.code === code) return data.name;
  });
}

export function getDefaultLanguage(code: string): Language {
  const language = languages.find(data => data.code === code);
  if (language) {
    return language;
  } else {
    return languages.find(data => data.code === 'en');
  }
}

export function getAllLanguages(): Language[] {
  return languages;
}

export function getAllLanguagesEN(): Language[] {
  return languagesEN;
}
